// import {pinyin} from "pinyin-pro";
import TinyPinyin from 'tiny-pinyin';

export const HanToNumber = (section) => {
	const dict = {
		'一': 1,
		'二': 2,
		'三': 3,
		'四': 4,
		'五': 5,
		'六': 6,
		'七': 7,
		'八': 8,
		'九': 9,
		'十': 10,
		'十一': 11,
	};
	const hanNum = section.match(/第(.+)届/)[1];
	// 如果是两位数，如：十二，最大到二十，已经可以满足本项目需求了
	if (hanNum.length > 1) {
		// console.log("id    ", hanNum, hanNum[0], hanNum[1])
		return dict[hanNum[0]] + dict[hanNum[1]] + 1000;
	}
	return dict[hanNum] + 1000;
};

// 将字段名改成驼峰形式：user_id => userId，主要解决联合查表后返回的数据再写入数据库的问题
export const convertToCamelCase = (str) => {
	const arr = str.split('_');
	let camelCaseString = '';
	for (let i = 0; i < arr.length; i++) {
		if (i === 0) {
			camelCaseString += arr[i];
		} else {
			camelCaseString += arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
		}
	}
	return camelCaseString;
};

// 将 Object 中 user_id 转成 userId 形式
export const camelObj = (objData) => {
	return Object.keys(objData).map(key => {
		let newKey = key;
		if (key.includes('_')) {
			newKey = convertToCamelCase(key);
		}
		return {[newKey]: objData[key]};
	}).reduce((prev, next) => ({...prev, ...next}));
};

// 去掉 [{'userName': '张 三'}, {'userPost': '会 长'}] 中的空格
export const noSpaceList = (dataList) => {
	return dataList.map(objData => {
		return Object.keys(objData).map(key => {
			let newKey = key.replace(' ', '').replace(' ', '');
			let newValue = objData[key].replace(' ', '').replace(' ', '');
			return {[newKey]: newValue};
		}).reduce((prev, next) => ({...prev, ...next}));
	});
};

// 将 memberName 转换成 partyMemberName
export const addPrefix = (oldName) => {
	return 'party' + oldName.charAt(0).toUpperCase() + oldName.slice(1);
};

// 将用户输入的可能任何格式的时间形式全部转成标准的 1988-01-01 形式
export function convertDateString(dateString) {
	if (dateString) {
		let formatDateString = dateString.replace(' ', '').replace(' ', '').replace('月日', '月').replace('年月', '年');
		const regex = /(\d{2,4}[-\/.]\d{1,2}[-\/.]\d{1,2})|(\d{2,4}年\d{1,2}月\d{1,2}日)|(\d{2,4}[-\/.]\d{1,2})|(\d{2,4}年\d{1,2}月)|(\d{2,4}[-\/.])|(\d{2,4}年)/;
		const matchedDate = formatDateString.match(regex);
		if (matchedDate) {
			let dateObj;
			if (matchedDate[0].includes('年') || matchedDate[0].includes('月') || matchedDate[0].includes('日')) {
				dateObj = new Date(matchedDate[0].replace(/[年月]/g, '/').replace('日', ''));
			} else {
				dateObj = new Date(matchedDate[0]);
			}
			const year = dateObj.getFullYear().toString();
			const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
			const day = dateObj.getDate().toString().padStart(2, '0');
			return `${year}-${month}-${day}`;
		}
		return dateString;
	}
}

// 测试数据
// const dateStrings = [
//     "88-1-1",
//     "88年1月1日",
//     "88/1/1",
//     "88.1.1",
//     "1988-1-1",
//     "1988年1月1日",
//     "1988/1/1",
//     "1988.1.1",
//     "88-1",
//     "88年1月",
//     "88/1",
//     "88.1",
//     "1988-1",
//     "1988年1月",
//     "1988/1",
//     "88-",
//     "88年",
//     "88/",
//     "88.",
//     "1988-",
//     "1988年",
//     "1988/"
// ];
// dateStrings.forEach(dateString => {
//     const convertedDate = convertDateString(dateString);
//     // console.log(`${dateString} 转换后的日期为：${convertedDate}`);
// });

export function getFirstLetters(sentence) {
	const characters = TinyPinyin.convertToPinyin(sentence, ' ', true);
	return characters.split(' ').map(item => item[0]).join('');
}
